import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/products/{creatorSlug}/{productSlug}/tags';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['body'] & THIS_API['params'];
type Output = THIS_API['response'];

const handleProductTags = async ({ productSlug, creatorSlug, ...body }: Input ): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorSlug, productSlug });
  const response = await noodleApiClient.post(path, body);
  return response.data;
};

export default handleProductTags;
